import {
  FETCH_CUSTOM_EVENT_MAPPINGS_URL,
  FETCH_PURCHASE_MAPPINGS_URL,
  FETCH_USER_MAPPINGS_URL,
  MAPPINGS_URL,
} from 'api/MappingsAPI';
import { ClientDataType } from 'modules/queryBuilder/types';
import { UseMappingsHookProps } from '../hooks/queries/mappings/types';

type MappingsRequestParams = {
  endpoint: string;
  params: Record<string, any>;
  config: Record<string, any>;
};

export const getMappingsRequestParams = ({
  dataType,
  isEnabled = true,
}: UseMappingsHookProps): MappingsRequestParams => {
  const defaultParams = {
    params: {},
    config: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      enabled: isEnabled,
    },
  };

  switch (dataType) {
    case ClientDataType.User:
      return { ...defaultParams, endpoint: FETCH_USER_MAPPINGS_URL };
    case ClientDataType.CustomEvent:
      return { ...defaultParams, endpoint: FETCH_CUSTOM_EVENT_MAPPINGS_URL };
    case ClientDataType.Purchase:
      return { ...defaultParams, endpoint: FETCH_PURCHASE_MAPPINGS_URL };
    default:
      return { ...defaultParams, endpoint: MAPPINGS_URL, params: { dataType } };
  }
};
